export default {
	collapseToggleLabel: 'Collapse Mobilize vehicles',
	expandToggleLabel: 'Expand Mobilize vehicles',
	logoAlt: 'Mobilize',
	nextLabel: 'Next vehicles',
	prevLabel: 'Previous vehicles',
	seeAllLabel: 'See all',
	subtitle: 'These vehicles are exclusive to the Mobilize dealer network',
	title: 'Mobilize on Motorway',
};
